import { Tooltip } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { useFlag } from "@unleash/proxy-client-react";
import axios from "axios";
import { differenceInDays, format, isValid, parseISO } from "date-fns";
import React, { useEffect, useMemo, useState } from "react";
import BlockUi from "react-block-ui";
import SVG from "react-inlinesvg";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import PaymentLinkModal from "../../../components/PaymentLinkModal";
import { generateTraceId } from "../../../helpers";
import FloatToCurrency from "../../../helpers/FloatToCurrency";
import { getCardsToMigrate } from "../../../helpers/payment/migration";
import {
  cancelSubscription,
  getActivePaymentLink,
  getActivePaymentLinkV2,
} from "../../../helpers/subscription";
import CancelModal from "./CancelModal";
import ClientAccessToggle from "./ClientAccessToggle";
import CourtesyModal from "./CourtesyModal";
import PixModal from "./PixModal";
import UserAccessHistory from "./UserAccessHistory";
import { config } from "../../../../config/envs";
import { useFinanceiroCourtesySubmit } from "./financeiro.courtesy.hook";

const list_status = [
  { id: "paid", text: "Ativo" },
  { id: "active", text: "Ativo" },
  { id: "unpaid", text: "Pagamento Pendente" },
  { id: "waiting_payment", text: "Aguardando Pagamento" },
  { id: "canceled", text: "Cancelado" },
  { id: "trialing", text: "Período de Teste" },
  { id: "pending_payment", text: "Pagamento Pendente" },
  { id: "pending", text: "Pagamento Pendente" },
  { id: "ended", text: "Finalizado" },
  { id: "failed", text: "Falha no Pagamento" },
  { id: "refused", text: "Recusado" },
];
const payment_methods = [
  {
    id: "credit_card",
    icon: "fas fa-credit-card",
    text: "CARTÃO DE CRÉDITO",
  },
  { id: "boleto", icon: "fas fa-barcode", text: "BOLETO" },
  { id: "pix", icon: null, text: "PIX" },
];

const canceledStatus = ["canceled", "CANCELED"];

export default function Financeiro(props) {
  const dispatch = useDispatch();
  const isFeatureFlagEnabled = useFlag("EnablePixPayments");
  const enableOrganicMigration = useFlag("enableOrganicMigrationAdmin");
  const [migrationData, setMigrationData] = useState(null);
  const [isSettlingCharge, setIsSettlingCharge] = useState(false);
  const [isLoadingManualSync, setIsLoadingManualSync] = useState(false);
  const [isLoadingPaymentLink, setIsLoadingPaymentLink] = useState(false);
  const [isCancelingModal, setIsCancelingModal] = useState(false);
  const [isPixModal, setIsPixModal] = useState(false);
  const [pixLoading, setPixLoading] = useState(false);
  const [pixData, setPixData] = useState(null);
  const [paymentLinkModal, setPaymentLinkModal] = useState({});
  const [isCourtesyModalOpen, setIsCourtesyModalOpen] = useState(false);
  const [isCourtesyLoading, setIsCourtesyLoading] = useState(false);
  const { createCourtesy, useJusSub: useJusSubCourtesy } =
    useFinanceiroCourtesySubmit(props.cliente_id);
  const isUserAccessFlagEnabled = useFlag("USER_ACCESS_CONTROL");
  const customer = useSelector(
    state => state.subscription.customer
  );

  const user = useSelector(state => state.auth.user);
  const clientSubscription = useSelector(
    state => state.app.client_subscription
  );
  const isLoadingClientSubscription = useSelector(
    state => state.app.is_loading_client_subscription
  );
  const isDeleted = props.formik.values.deleted_at;
  const settleCharge = async () => {
    if (
      window.confirm(
        "Confirma pagamento via PIX? Ação não válida para pagamento via boleto."
      )
    ) {
      setIsSettlingCharge(true);
      try {
        const response = await axios.post(
          process.env.REACT_APP_API_URL + "/clients/settleCharge",
          { id: props.cliente_id },
          {
            headers: {
              "x-trace-id": generateTraceId()
            }
          }
        );
        if (response && response.data.success) {
          toast.success("Pagamento baixado com sucesso!");
          dispatch({
            type: "LOAD_CLIENT_SUBSCRIPTION",
            payload: {
              id: props.cliente_id,
              useV2: !!clientSubscription?.external_id,
            },
          });
        } else {
          toast.error("Ocorreu um erro ao dar baixa no pagamento.");
        }
      } catch (err) {
        toast.error("Ocorreu um erro ao dar baixa no pagamento.");
      }
      setIsSettlingCharge(false);
    }
  };

  const upgradeModal = () => {
    let title;
    let subtitle;
    if (clientSubscription.info.status === "canceled") {
      title = "Reativar plano";
      subtitle = "Basta escolher um plano para reativar agora mesmo.";
    } else {
      title = "Upgrade de plano";
      subtitle = "Basta escolher um plano para realizar o upgrade agora mesmo.";
    }
    dispatch({
      type:
        clientSubscription.info.provider === "pagarme_v5" ||
        enableOrganicMigration
          ? "SET_MODAL_SUBSCRIPTION_POLLING"
          : "SET_MODAL_SUBSCRIPTION",
      payload: {
        visible: true,
        title: title,
        subtitle: subtitle,
        client_id: props.cliente_id,
        migrationData: migrationData,
        callback: () => {
          dispatch({
            type: "LOAD_CLIENT_SUBSCRIPTION",
            payload: {
              id: props.cliente_id,
              useV2: !!clientSubscription?.external_id,
            },
          });
        },
      },
    });
  };

  const handleCancel = async (reason) => {
    try {
      await cancelSubscription(props.cliente_id, user.client_id, reason);
      toast.success("A assinatura foi cancelada com sucesso.");
      dispatch({
        type: "LOAD_CLIENT_SUBSCRIPTION",
        payload: { id: props.cliente_id, useV2: isJussubClient },
      });
      setIsCancelingModal(false);
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          "Ocorreu um erro ao cancelar a assinatura, por favor, tente novamente mais tarde."
      );
    }
  };

  const cancelClick = () => {
    setIsCancelingModal(true);
  };

  const manualSync = async (subscription_id) => {
    if (isJussubClient) return;
    setIsLoadingManualSync(true);
    try {
      const response = await axios.post(
        config.app.adminBaseUrl +
          `/subscription/manual-sync/${subscription_id}`,
        {},
        {
          headers: {
            "x-trace-id": generateTraceId(),
          },
        },
      );
      if (![200, 201, 204].includes(response.status)) {
        throw new Error("Erro ao sincronizar assinatura.");
      }
      toast.success("A assinatura foi sincronizada com sucesso.");
      dispatch({
        type: "LOAD_CLIENT_SUBSCRIPTION",
        payload: {
          id: props.cliente_id,
          useV2: !!clientSubscription?.external_id,
        },
      });
    } catch {
      toast.error(
        "Ocorreu um erro ao sincronizar a assinatura, por favor, tente novamente mais tarde.",
      );
    } finally {
      setIsLoadingManualSync(false);
    }
  };

  const safeDateParse = (dateString, formatStr) => {
    if (!dateString) {
      return "-";
    }

    let parsed;

    if (dateString.endsWith("Z")) {
      const localDateString = dateString.replace("Z", "");
      parsed = parseISO(localDateString);
    } else {
      parsed = parseISO(dateString);
    }

    if (!isValid(parsed)) {
      return "-";
    }

    return format(parsed, formatStr);
  };

  const handlePix = async () => {
    if (!isFeatureFlagEnabled) {
      return;
    }
    if (
      !clientSubscription?.client_id ||
      !clientSubscription?.plan_details?.gateway_id
    ) {
      toast.error(
        "Dados da assinatura incompletos. Por favor, recarregue a página.",
      );
      return;
    }
    try {
      setPixLoading(true);
      const response = await axios.post(
        process.env.REACT_APP_JUSBILL_URL +
          `/charges/pix/${clientSubscription.client_id}`,
        {
          plan_id: clientSubscription.plan_details.gateway_id
        },
        {
          headers: {
            "x-trace-id": generateTraceId()
          }
        }
      );
      if (![200, 201, 204].includes(response.status)) {
        throw new Error("Erro ao gerar o pix.");
      }
      const lastTx =
        response?.data?.charges?.[0]?.last_transaction ||
        response?.data?.last_transaction;
      if (!lastTx?.expires_at) {
        throw new Error("Resposta inválida ao gerar PIX (dados ausentes).");
      }
      const timer = Math.floor(
        (new Date(lastTx.expires_at) - new Date()) / 1000
      );
      setPixData({ ...response.data, timer });
      setIsPixModal(true);
    } catch (error) {
      console.error("Erro ao gerar PIX:", error);
      toast.error(
        error.response?.data?.message ||
          "Ocorreu um erro ao gerar o pix, por favor, tente novamente mais tarde.",
      );
    } finally {
      setPixLoading(false);
    }
  };

  const handleCreateCourtesy = async data => {
    if (!props.cliente_id) {
      toast.error("Cliente não encontrado.");
      return;
    }
    setIsCourtesyLoading(true);
    try {
      const response = await createCourtesy(data);

      if (![200, 201, 204].includes(response.status)) {
        throw new Error("Erro ao criar cortesia.");
      }

      toast.success("Cortesia criada com sucesso!");
      setIsCourtesyModalOpen(false);
      dispatch({
        type: "LOAD_CLIENT_SUBSCRIPTION",
        payload: { id: props.cliente_id }
      });
    } catch (error) {
      toast.error(
        error.response?.data?.message ||
          "Ocorreu um erro ao criar a cortesia, por favor, tente novamente."
      );
    } finally {
      setIsCourtesyLoading(false);
    }
  };

  const isPeriodEndingSoon = () => {
    const allowedStatuses = [
      "unpaid",
      "waiting_payment",
      "pending_payment",
      "pending",
      "failed",
      "canceled"
    ];
    if (allowedStatuses.includes(clientSubscription.info.status)) return true;
    if (!clientSubscription.info?.current_period_end) return false;
    const endDate = parseISO(clientSubscription.info.current_period_end);
    if (!isValid(endDate)) return false;
    return differenceInDays(endDate, new Date()) <= 2;
  };

  const handleCheckPaymentLink = async (originFlow) => {
    try {
      setIsLoadingPaymentLink(true);

      const func = isJussubClient
        ? getActivePaymentLinkV2
        : getActivePaymentLink;
      const data = await func(clientSubscription?.client_id);

      if (!data.success) {
        setPaymentLinkModal({ isOpen: true, originFlow });
      } else {
        setPaymentLinkModal({ isOpen: true, originFlow, data: { ...data, email: customer?.email } });
      }
    } catch (error) {
      toast.error("Ocorreu um erro ao verificar o link de pagamento.");
    } finally {
      setIsLoadingPaymentLink(false);
    }
  };

  const handleUpdatePlanOrActivateButton = async () => {
    const flow = canceledStatus.includes(clientSubscription.info.status)
      ? "reactivation_plan"
      : "upgrade_plan";
    if (flow === "reactivation_plan" && clientSubscription.external_id) {
      // call reativation route
      toast.warn("reactivation will be implemented for jussub ASP...");
      return;
    }

    if (
      clientSubscription.info.provider === "pagarme_v5" ||
      clientSubscription.external_id
    ) {
      await handleCheckPaymentLink(flow);
    } else {
      upgradeModal();
    }
  };

  const isJussubClient = useMemo(() => !!customer?.external_id, [
    customer?.external_id,
  ]);

  const hasCustomerLoaded = Object.keys(customer).length > 0;

  useEffect(() => {
    if (customer?.id === props.cliente_id) return;
    dispatch({
      type: "LOAD_SUBSCRIPTION_CUSTOMER",
      payload: { id: props.cliente_id },
    });
  }, [dispatch, props.cliente_id, customer?.id]);

  useEffect(() => {
    if (!hasCustomerLoaded) return;
    dispatch({
      type: "LOAD_CLIENT_SUBSCRIPTION",
      payload: { id: props.cliente_id, useV2: isJussubClient },
    });

    if (isJussubClient) {
      dispatch({
        type: "LOAD_CLIENT_PLAN_OFFERS",
        payload: { client_id: props.cliente_id },
      });
    }

    return () => {
      dispatch({ type: "CLEAR_CLIENT_PLAN_OFFERS" });
    };
  }, [props.cliente_id, isJussubClient, hasCustomerLoaded, dispatch]);

  useEffect(() => {
    if (!enableOrganicMigration || isJussubClient) return;
    if (!clientSubscription?.client_id || !clientSubscription?.info) return;

    let isMounted = true;

    getCardsToMigrate(clientSubscription.client_id)
      .then((data) => {
        if (isMounted && clientSubscription.info?.provider === "pagarme") {
          setMigrationData({
            ...data,
            enableOrganicMigration,
            currentProvider: clientSubscription.info?.provider,
            currentSubscriptionId: clientSubscription.info?.subscription_id,
          });
        }
      })
      .catch(() => {
        if (isMounted) setMigrationData(null);
      });

    return () => {
      isMounted = false;
    };
  }, [
    enableOrganicMigration,
    isJussubClient,
    clientSubscription?.client_id,
    clientSubscription?.info,
  ]);

  return (
    <BlockUi
      tag="div"
      blocking={
        isLoadingClientSubscription || isSettlingCharge || isLoadingManualSync
      }
    >
      <div className="row mb-12 d-flex justify-content-between">
        <div>
          <h1 className="azul-cabecalho">Situação da assinatura</h1>
          <p className="subheader-text mb-5">
              Informações sobre a assinatura do cliente.
          </p>
        </div>
        {isUserAccessFlagEnabled && (
          <ClientAccessToggle clientId={props.cliente_id} />
        )}
      </div>
      {Object.keys(clientSubscription).length > 0 && (
        <>
          <div className="row mb-5">
            <div className="col-xl-4 oportunidade">
              <div
                style={{
                  backgroundColor: "#fff",
                  padding: "20px",
                  borderRadius: "10px",
                  border: "1px solid #eaeaea"
                }}
              >
                <h2 className="azul-cabecalho" style={{ lineHeight: 1 }}>
                    PLANO CONTRATADO
                </h2>
                <p
                  style={{
                    fontSize: "32px",
                    letterSpacing: "-0.04em",
                    fontWeight: "bold",
                    color: "#41c78f",
                    lineHeight: 1
                  }}
                >
                  {clientSubscription.info.plan}
                </p>

                <p style={{ opacity: "0.6", marginBottom: "0" }}>
                    Status:{" "}
                  <strong>
                    {
                    list_status.find(
                      (status) =>
                        status.id === clientSubscription?.info?.status,
                    )?.text ?? clientSubscription?.info?.status}
                  </strong>
                  {clientSubscription.info.status === "active" &&
                      clientSubscription.info.payment_method === "pix" && (
                    <span
                      className="badge ml-2"
                      style={{
                        color: "#01AB7D",
                        backgroundColor: "#E6F7F2",
                        fontWeight: "bold"
                      }}
                    >
                          Pago por pix
                    </span>
                  )}
                  {clientSubscription.info.reason?.message && (
                    <Tooltip
                      title={
                        clientSubscription.info.reason.message +
                          " - " +
                          clientSubscription.info.reason.details
                      }
                      placement={"right"}
                      arrow
                    >
                      <span className="svg-icon svg-icon-sm ml-2">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Code/Info-circle-v2.svg"
                          )}
                        ></SVG>{" "}
                      </span>
                    </Tooltip>
                  )}
                </p>
                <p style={{ opacity: "0.6", marginBottom: "0" }}>
                    Valor cobrado:{" "}
                  <strong>
                    {clientSubscription.info.charged_amount != null
                      ? `R$ ${FloatToCurrency(clientSubscription.info.charged_amount)}`
                      : "—"}
                  </strong>
                </p>
                {clientSubscription.info.subscription_provider !== "jussub" && (
                  <p style={{ opacity: "0.6", fontSize: "12px", marginBottom: "0" }}>
                      Valor cobrado disponível apenas para assinaturas JusSub.
                  </p>
                )}
                <p style={{ opacity: "0.6" }}>
                    Valor do plano:{" "}
                  <strong>
                      R$ {FloatToCurrency(clientSubscription.info.plan_amount)}
                  </strong>
                </p>

                <div>
                  <p className="tipo-campo">INÍCIO DO PERÍODO ATUAL</p>
                  <p className="campo">
                    {safeDateParse(
                      clientSubscription.info.current_period_start,
                      "dd/MM/yyyy HH:mm"
                    )}
                  </p>
                </div>

                <div>
                  <p className="tipo-campo">FIM DO PERÍODO ATUAL</p>
                  <p className="campo">
                    {safeDateParse(
                      clientSubscription.info.current_period_end,
                      "dd/MM/yyyy HH:mm"
                    )}
                  </p>
                </div>

                <div>
                  <p className="tipo-campo">ÚLTIMA ATUALIZAÇÃO</p>
                  <p className="campo">
                    {safeDateParse(
                      clientSubscription.info.latest_update,
                      "dd/MM/yyyy HH:mm"
                    )}
                  </p>
                </div>

                <div>
                  <p className="tipo-campo">FORMA DE PAGAMENTO</p>
                  <p className="campo">
                    {clientSubscription.info.payment_method === "pix" ? (
                      <SVG src="/media/svg/icons/Shopping/Pix.svg" />
                    ) : (
                      <i
                        className={`icon-md fas ${payment_methods.find(
                          (method) =>
                            method.id ===
                              clientSubscription.info.payment_method
                        )?.icon ?? ""}`}
                      ></i>
                    )}
                    <span className="ml-1">
                       {payment_methods.find(
                          (status) =>
                            status.id ===
                            clientSubscription.info.payment_method,
                        )?.text ?? clientSubscription.info.payment_method}
                    </span>
                  </p>
                </div>

                {clientSubscription.info?.tickets?.length > 0 && (
                  <div>
                    {clientSubscription.info.tickets.map((ticket) => (
                      <p key={ticket.pdf} className="">
                        <i className="icon-md fas fa-link mr-1"></i>
                        <a
                          href={ticket.pdf}
                          target="_blank"
                          rel="noreferrer"
                          style={{
                            pointerEvents: isDeleted ? "none" : "auto",
                            opacity: isDeleted ? "0.5" : "1",
                          }}
                        >
                            ACESSAR BOLETO
                        </a>
                      </p>
                    ))}
                  </div>
                )}

                {clientSubscription.info.payment_method === "credit_card" &&
                  clientSubscription.info?.card_brand &&
                  clientSubscription?.info?.card_last_digits ? (
                    <>
                      <div>
                        <p className="tipo-campo">BANDEIRA DO CARTÃO</p>
                        <p className="campo">
                          {clientSubscription.info?.card_brand?.toUpperCase()}{" "}
                        </p>
                      </div>
                      <div>
                        <p className="tipo-campo">ÚLTIMOS DIGITOS DO CARTÃO</p>
                        <p className="campo">
                          {clientSubscription?.info?.card_last_digits}
                        </p>
                      </div>
                    </>
                  ) : (
                    <Alert className="tipo-campo" severity="warning">
                      Cliente sem cartão de crédito vinculado a assinatura
                    </Alert>
                  )}
              </div>
            </div>
          </div>
          {isUserAccessFlagEnabled && (
            <UserAccessHistory clienteId={props.cliente_id} />
          )}
          {/* {clientSubscription.info.provider !== "pagarme_v5" ? (
              <a
                href={
                  clientSubscription.info.provider !== "pagarme_v5" &&
                props.formik.values.manage_url
                }
                target="_BLANK"
                className={`btn btn-secondary mb-5 ${clientSubscription.info
                  .provider === "pagarme_v5" && "text-muted"}`}
                style={{
                  display: "block",
                  width: "200px",
                  pointerEvents:
                  clientSubscription.info.provider === "pagarme_v5"
                    ? "none"
                    : "auto"
                }}
                rel="noreferrer"
              >
              URL ASSINATURA PAGARME
              </a>
          ) : ( */}
          <button
            type="button"
            className={"btn btn-secondary mb-5"}
            style={{ display: "block", width: "200px" }}
            rel="noreferrer"
            onClick={() => handleCheckPaymentLink("url_subscription")}
            disabled={isLoadingPaymentLink}
          >
            URL ASSINATURA
          </button>
          {/* )} */}
        </>
      )}
      {Object.keys(clientSubscription).length > 0 && !isDeleted && (
        <button
          type="button"
          className="btn btn-secondary mr-5 mb-5"
          style={{ width: "200px", display: "block" }}
          onClick={() => handleUpdatePlanOrActivateButton()}
          disabled={isLoadingPaymentLink}
        >
          {canceledStatus.includes(clientSubscription.info.status)
            ? "REATIVAR PLANO"
            : "UPGRADE DE PLANO"}
        </button>
      )}
      {Object.keys(clientSubscription).length > 0 &&
        clientSubscription.info.status &&
        !canceledStatus.includes(clientSubscription.info.status) &&
        !isDeleted && (
        <button
          type="button"
          style={{ width: "200px", display: "block" }}
          className="btn btn-danger mr-5 mb-5"
          onClick={() => cancelClick()}
        >
            CANCELAR ASSINATURA
        </button>
      )}
      {Object.keys(clientSubscription).length > 0 && !isDeleted && (
        <button
          type="button"
          className="btn btn-primary mr-5 mb-5"
          style={{
            width: "200px",
            pointerEvents:
              clientSubscription.info.provider === "pagarme_v5"
                ? "none"
                : "auto"
          }}
          onClick={settleCharge}
          disabled={
            clientSubscription.info.provider === "pagarme_v5" ||
            !!clientSubscription.external_id ||
            isDeleted
          }
        >
          DAR BAIXA NO PAGAMENTO PIX
        </button>
      )}
      {!isDeleted && (
        <button
          type="button"
          className="btn btn-outline-primary mr-5 mb-5"
          style={{ width: "200px", display: "block" }}
          onClick={() => setIsCourtesyModalOpen(true)}
        >
          CRIAR CORTESIA
        </button>
      )}
      {isCancelingModal && (
        <CancelModal setOpen={setIsCancelingModal} onConfirm={handleCancel} />
      )}

      {clientSubscription.info?.provider === "pagarme" && !isDeleted && (
        <button
          type="button"
          className="btn btn-warning mr-5 mb-5"
          style={{ width: "200px", display: "block" }}
          onClick={() => manualSync(clientSubscription.info.subscription_id)}
        >
          SINCRONIZAR
        </button>
      )}
      {isFeatureFlagEnabled &&
        clientSubscription.info?.provider === "pagarme_v5" &&
        (clientSubscription.info?.payment_method === "boleto" ||
          clientSubscription.info?.payment_method === "pix") &&
        isPeriodEndingSoon() && (
        <button
          type="button"
          style={{ width: "200px", display: "block" }}
          className="btn btn-outline-primary mr-5 mb-5 font-weight-bold"
          onClick={() => handlePix()}
          disabled={pixLoading}
        >
          {pixLoading ? (
            <span
              className="spinner-border align-self-center"
              role="status"
              aria-hidden="true"
              style={{ height: "18px", width: "18px" }}
            ></span>
          ) : (
            "Pagar com o Pix"
          )}
        </button>
      )}
      {isPixModal &&
        (pixData?.charges?.[0]?.last_transaction ||
          pixData?.last_transaction) && (
          <PixModal
            setOpen={setIsPixModal}
            pixCode={
              pixData.charges?.[0]?.last_transaction?.qr_code ||
              pixData?.last_transaction?.qr_code
            }
            pixQR={
              pixData.charges?.[0]?.last_transaction?.qr_code_url ||
              pixData?.last_transaction?.qr_code_url
            }
            pixTimer={pixData.timer}
            clientId={clientSubscription.client_id}
          />
        )}

      {paymentLinkModal.isOpen && (
        <PaymentLinkModal
          isOpen={paymentLinkModal.isOpen}
          onClose={() =>
            setPaymentLinkModal({ ...paymentLinkModal, isOpen: false })
          }
          originFlow={paymentLinkModal.originFlow}
          paymentLink={paymentLinkModal.data}
          isJussub={isJussubClient}
        />
      )}
      <CourtesyModal
        isOpen={isCourtesyModalOpen}
        onClose={() => setIsCourtesyModalOpen(false)}
        onConfirm={handleCreateCourtesy}
        isLoading={isCourtesyLoading}
        clientEmail={props.formik.values.email}
        currentPlanName={clientSubscription?.plan_details?.name || clientSubscription?.info?.plan}
        useJusSub={useJusSubCourtesy}
      />
    </BlockUi>
  );
}
